module.exports = __webpack_public_path__ + "static/ronald_cain-f0bfe621296cb6a7b5b5c0f669f48818.png";